"use client"
import Link from "next/link";
import { useUserInfoStore } from "@/models/userInfo";
import { logoutService } from "@/services/user";
import { addToast } from "@heroui/react";
import useStatusStore from "@/models/status";
import { useState } from "react";
import { clearUserId } from "@/lib/log";

export default function Header() {
  const { userInfo, isLogin, logOut } = useUserInfoStore();
  const { clearLikedDocList, clearFollowedUserList } = useStatusStore();
  function handleLogout() {
    logoutService();
    logOut();
    clearUserId();
    clearLikedDocList();
    clearFollowedUserList();
    window.location.reload();
  }
  const [showMenu, setShowMenu] = useState(false);
  return (
    <header className="fixed left-0 right-0 top-0 w-full z-50 bg-white border-b border-gray-200 px-3 lg:px-9 md:px-6">
      <div className="flex items-center justify-between h-16">
        {/* Logo */}
        <div className="flex items-center">
          <div className="block md:hidden mr-2 active:bg-gray-100 rounded-lg p-2">
            <Menu />
          </div>
          <Link
            href="/"
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
          >
            {/* <img src={SITE_CONFIG.logo} alt="logo" width={60} height="auto" /> */}
            <svg width="49" height="24" viewBox="0 0 64 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M58.965 24C58.0405 24 57.3294 23.7867 56.8317 23.36C56.3516 22.9333 56.1116 22.4533 56.1116 21.92C56.1116 21.4578 56.2805 21.0578 56.6183 20.72C56.9561 20.3822 57.4539 20.2133 58.1116 20.2133C58.3428 20.2133 58.6094 20.24 58.9117 20.2933C59.2317 20.3289 59.4717 20.3556 59.6317 20.3733C59.6139 19.9111 59.5072 19.4756 59.3117 19.0667C59.1339 18.6578 58.9028 18.2667 58.6183 17.8933C58.3339 17.5022 58.0672 17.1644 57.8183 16.88C57.2672 17.9289 56.7161 18.8 56.165 19.4933C55.6316 20.1867 55.045 20.8444 54.405 21.4667C54.085 21.7867 53.7472 21.9467 53.3916 21.9467C53.1072 21.9467 52.8761 21.8489 52.6983 21.6533C52.5205 21.44 52.4316 21.1822 52.4316 20.88C52.4316 20.5244 52.5561 20.1956 52.805 19.8933L53.1516 19.4667C54.1294 18.2578 54.8672 17.2622 55.365 16.48C55.685 15.9644 56.005 15.3511 56.325 14.64C56.6628 13.9289 57.0983 12.96 57.6317 11.7333C57.9694 10.9511 58.6717 10.56 59.7383 10.56C60.2361 10.56 60.5828 10.6044 60.7783 10.6933C60.9739 10.7822 61.0717 10.9244 61.0717 11.12C61.0717 11.2267 61.0361 11.3956 60.965 11.6267C60.8939 11.8578 60.7961 12.0889 60.6717 12.32C60.3517 12.96 60.1917 13.5022 60.1917 13.9467C60.1917 14.2133 60.2805 14.5067 60.4583 14.8267C60.6539 15.1467 60.9472 15.5467 61.3383 16.0267C61.9072 16.7733 62.3339 17.4133 62.6183 17.9467C62.9205 18.4622 63.0717 19.0311 63.0717 19.6533C63.0717 20.4 62.8939 21.1111 62.5383 21.7867C62.2005 22.4444 61.7205 22.9778 61.0983 23.3867C60.4761 23.7956 59.765 24 58.965 24Z" fill="black"></path><path d="M55.4294 17.3333C55.6605 17.3333 55.8383 17.44 55.9627 17.6533C56.105 17.8667 56.1761 18.16 56.1761 18.5333C56.1761 19.2444 56.0072 19.7956 55.6694 20.1867C54.905 21.1289 54.0694 21.9022 53.1627 22.5067C52.2561 23.1111 51.2161 23.4133 50.0427 23.4133C46.4161 23.4133 44.6027 20.8622 44.6027 15.76C44.6027 14.9778 44.6294 14.1867 44.6827 13.3867H43.6427C43.1094 13.3867 42.7449 13.2889 42.5494 13.0933C42.3716 12.8978 42.2827 12.5867 42.2827 12.16C42.2827 11.1644 42.6827 10.6667 43.4827 10.6667H45.0027C45.3049 8.71111 45.7672 6.92444 46.3894 5.30667C47.0116 3.68889 47.7583 2.4 48.6294 1.44C49.5183 0.479999 50.4694 0 51.4827 0C52.2294 0 52.8161 0.328889 53.2427 0.986667C53.6694 1.64444 53.8827 2.47111 53.8827 3.46667C53.8827 6.22222 52.7272 8.62222 50.4161 10.6667H53.4027C53.6872 10.6667 53.8916 10.7289 54.0161 10.8533C54.1405 10.9778 54.2027 11.2089 54.2027 11.5467C54.2027 12.7733 53.1983 13.3867 51.1894 13.3867H47.9361C47.9005 14.2756 47.8827 14.9689 47.8827 15.4667C47.8827 17.3156 48.0961 18.6133 48.5227 19.36C48.9672 20.1067 49.6605 20.48 50.6027 20.48C51.3672 20.48 52.0427 20.2489 52.6294 19.7867C53.2161 19.3244 53.9094 18.6311 54.7094 17.7067C54.9227 17.4578 55.1627 17.3333 55.4294 17.3333ZM50.7627 2.56C50.4961 2.56 50.1938 2.89778 49.8561 3.57333C49.5361 4.23111 49.2249 5.15555 48.9227 6.34666C48.6383 7.52 48.3983 8.82666 48.2027 10.2667C49.2516 9.36 50.0338 8.34666 50.5494 7.22666C51.0827 6.08889 51.3494 5.05778 51.3494 4.13333C51.3494 3.08444 51.1538 2.56 50.7627 2.56Z" fill="black"></path><path d="M37.1159 24C36.1914 24 35.4803 23.7867 34.9825 23.36C34.5025 22.9333 34.2625 22.4533 34.2625 21.92C34.2625 21.4578 34.4314 21.0578 34.7692 20.72C35.107 20.3822 35.6048 20.2133 36.2625 20.2133C36.4936 20.2133 36.7603 20.24 37.0625 20.2933C37.3825 20.3289 37.6225 20.3556 37.7825 20.3733C37.7648 19.9111 37.6581 19.4756 37.4625 19.0667C37.2848 18.6578 37.0536 18.2667 36.7692 17.8933C36.4848 17.5022 36.2181 17.1644 35.9692 16.88C35.4181 17.9289 34.867 18.8 34.3159 19.4933C33.7825 20.1867 33.1959 20.8444 32.5559 21.4667C32.2359 21.7867 31.8981 21.9467 31.5425 21.9467C31.2581 21.9467 31.027 21.8489 30.8492 21.6533C30.6714 21.44 30.5825 21.1822 30.5825 20.88C30.5825 20.5244 30.707 20.1956 30.9559 19.8933L31.3025 19.4667C32.2803 18.2578 33.0181 17.2622 33.5159 16.48C33.8181 15.9644 34.1736 15.28 34.5825 14.4267C34.9914 13.5556 35.3914 12.6578 35.7825 11.7333C36.1203 10.9511 36.8225 10.56 37.8892 10.56C38.387 10.56 38.7336 10.6044 38.9292 10.6933C39.1248 10.7822 39.2225 10.9244 39.2225 11.12C39.2225 11.2267 39.187 11.3956 39.1159 11.6267C39.0448 11.8578 38.947 12.0889 38.8225 12.32C38.5025 12.96 38.3425 13.5022 38.3425 13.9467C38.3425 14.2133 38.4314 14.5067 38.6092 14.8267C38.8048 15.1467 39.0981 15.5467 39.4892 16.0267C40.0581 16.7733 40.4848 17.4133 40.7692 17.9467C41.0714 18.4622 41.2225 19.0311 41.2225 19.6533C41.2225 19.8311 41.2048 20.08 41.1692 20.4C42.0403 20.0622 43.0625 19.1644 44.2359 17.7067C44.4492 17.4578 44.6892 17.3333 44.9559 17.3333C45.187 17.3333 45.3648 17.44 45.4892 17.6533C45.6314 17.8667 45.7025 18.16 45.7025 18.5333C45.7025 19.2089 45.5337 19.76 45.1959 20.1867C44.307 21.2889 43.4536 22.0444 42.6359 22.4533C41.8359 22.8444 40.8403 23.0578 39.6492 23.0933C38.9381 23.6978 38.0936 24 37.1159 24Z" fill="black"></path><path d="M33.5809 17.3333C33.8121 17.3333 33.9898 17.44 34.1143 17.6533C34.2565 17.8667 34.3276 18.16 34.3276 18.5333C34.3276 19.2444 34.1587 19.7956 33.8209 20.1867C33.1632 20.9867 32.2298 21.7244 31.0209 22.4C29.8298 23.0756 28.5498 23.4133 27.1809 23.4133C25.3143 23.4133 23.8654 22.9067 22.8343 21.8933C21.8032 20.88 21.2876 19.4933 21.2876 17.7333C21.2876 16.5067 21.5454 15.3689 22.0609 14.32C22.5765 13.2533 23.2876 12.4089 24.1943 11.7867C25.1187 11.1644 26.1587 10.8533 27.3143 10.8533C28.3454 10.8533 29.1721 11.1644 29.7943 11.7867C30.4165 12.3911 30.7276 13.2178 30.7276 14.2667C30.7276 15.4933 30.2832 16.5511 29.3943 17.44C28.5232 18.3111 27.0387 19.0044 24.9409 19.52C25.3854 20.3378 26.2298 20.7467 27.4743 20.7467C28.2743 20.7467 29.1809 20.4711 30.1943 19.92C31.2254 19.3511 32.1143 18.6133 32.8609 17.7067C33.0743 17.4578 33.3143 17.3333 33.5809 17.3333ZM26.8609 13.4667C26.2032 13.4667 25.6432 13.8489 25.1809 14.6133C24.7365 15.3778 24.5143 16.3022 24.5143 17.3867V17.44C25.5632 17.1911 26.3898 16.8178 26.9943 16.32C27.5987 15.8222 27.9009 15.2444 27.9009 14.5867C27.9009 14.2489 27.8032 13.9822 27.6076 13.7867C27.4298 13.5733 27.1809 13.4667 26.8609 13.4667Z" fill="black"></path><path d="M21.52 17.3333C21.7511 17.3333 21.9289 17.44 22.0534 17.6533C22.1956 17.8666 22.2667 18.16 22.2667 18.5333C22.2667 19.2266 22.0978 19.7777 21.76 20.1866C20.7645 21.3777 19.7956 22.2133 18.8534 22.6933C17.9289 23.1733 16.8089 23.4133 15.4934 23.4133C14.5689 23.4133 13.7156 23.2977 12.9333 23.0666C12.1511 22.8355 11.2 22.4889 10.08 22.0266C9.12001 21.6177 8.26668 21.2889 7.52001 21.04C6.70223 21.9289 5.96445 22.5511 5.30667 22.9066C4.64889 23.2444 3.95556 23.4133 3.22667 23.4133C2.24889 23.4133 1.46667 23.1911 0.880001 22.7466C0.293334 22.2844 0 21.6889 0 20.96C0 20.4089 0.177778 19.9022 0.533334 19.44C0.906668 18.9777 1.42222 18.6133 2.08 18.3466C2.73778 18.08 3.50223 17.9466 4.37334 17.9466C4.87112 17.9466 5.24445 17.9555 5.49334 17.9733C8.97779 13.6355 12.1245 9.05775 14.9334 4.23997C13.4045 3.9733 11.8489 3.83997 10.2667 3.83997C8.22223 3.83997 6.72001 4.07997 5.76001 4.55997C4.81778 5.02219 4.34667 5.75997 4.34667 6.7733C4.34667 7.07552 4.38223 7.3333 4.45334 7.54664C4.52445 7.75997 4.63112 8.00886 4.77334 8.2933C4.93334 8.6133 5.01334 8.84441 5.01334 8.98664C5.01334 9.34219 4.84445 9.64441 4.50667 9.8933C4.18667 10.1244 3.81334 10.24 3.38667 10.24C2.94223 10.24 2.57778 10.1066 2.29334 9.83997C1.95556 9.53775 1.68 9.12886 1.46667 8.6133C1.27111 8.07997 1.17333 7.48441 1.17333 6.82664C1.17333 4.74664 2.03556 3.20886 3.76 2.2133C5.48445 1.21775 7.76001 0.719971 10.5867 0.719971C11.9911 0.719971 13.4222 0.799971 14.88 0.959971C16.3556 1.11997 17.7334 1.37775 19.0134 1.7333C19.5467 1.87553 19.9022 2.07997 20.08 2.34664C20.2578 2.59553 20.3467 2.92441 20.3467 3.3333C20.3467 3.8133 20.2222 4.18664 19.9734 4.4533C19.7245 4.71997 19.3778 4.8533 18.9334 4.8533H18.7467C16.8267 7.98219 14.88 10.9866 12.9067 13.8666C11.3245 16.16 10.2133 17.7155 9.57335 18.5333C10.6045 18.7644 11.5022 18.9777 12.2667 19.1733C13.2089 19.4222 13.9645 19.6089 14.5334 19.7333C15.12 19.84 15.6267 19.8933 16.0534 19.8933C17.0845 19.8933 17.9645 19.7244 18.6934 19.3866C19.44 19.0311 20.1422 18.4711 20.8 17.7066C21.0134 17.4577 21.2534 17.3333 21.52 17.3333Z" fill="black"></path></svg>
          </Link>
        </div>

        {/* Search and User */}
        <div className="flex items-center">
          {/* User Avatar */}
          {isLogin && (
            <div className="relative group block sm:hidden">
              <div
                className="flex items-center cursor-pointer hover:opacity-80 transition-opacity hover:bg-gray-100 rounded-full p-1"
                onClick={() => setShowMenu(!showMenu)}
              >
                <span className="text-sm hidden sm:block font-semibold mr-2">
                  {userInfo.nickname}
                </span>
                <img
                  src={userInfo.profile_url}
                  alt={userInfo.nickname}
                  width={32}
                  height={32}
                  className="rounded-full"
                />
              </div>
              {/* 下拉菜单 */}
              <div className={`absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 transition-all duration-200 z-50 py-5 ${showMenu ? "opacity-100 visible" : "opacity-0 invisible"}`}>
                <div className="flex items-center justify-center pb-3 text-sm font-semibold text-center">
                  {userInfo.nickname}
                </div>
                <div className="w-full h-px bg-gray-200" />
                <button
                  onClick={() => {
                    handleLogout();
                  }}
                  className="block w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors text-center"
                >
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header >
  );
}
import tabs from "@/constant/tabs";
import clsx from "clsx";

import { useEffect, useRef } from "react";

const Menu: React.FC = () => {
  const { isLogin } = useUserInfoStore();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const TOP = 64;

  // 关闭菜单时移除遮罩
  useEffect(() => {
    if (!showMenu) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setShowMenu(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showMenu]);

  return (
    <div className="relative" ref={menuRef}>
      <div className="h-[20px] w-[20px]">
        <div
          className="hamburger-menu"
          tabIndex={0}
          aria-label="open menu"
          onClick={() => setShowMenu(!showMenu)}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") setShowMenu(!showMenu);
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "30px",
            height: "21px",
            cursor: "pointer",
            marginRight: "20px"
          }}>
          <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref="#menu"></use>
            <symbol id="menu" viewBox="0 0 20 20"><path d="M3.25 4.167h13.5a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1 0-1.5M3.25 9.25h13.5a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1 0-1.5M16.75 14.333H3.25a.75.75 0 0 0 0 1.5h13.5a.75.75 0 0 0 0-1.5"></path></symbol></svg>
        </div>
      </div>
      {/* 动画菜单：从左到右滑入滑出 */}
      <div
        className={clsx(
          "fixed inset-0 z-40 transition-all duration-300 ease-in-out",
          showMenu ? "opacity-100 visible" : "opacity-0 invisible"
        )}
        aria-label="menu mask"
        tabIndex={0}
        onClick={() => setShowMenu(false)}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") setShowMenu(false);
        }}
      >
        {/* 遮罩 */}
        <div
          className={clsx(
            "absolute inset-0 bg-black/20 transition-opacity duration-300 ease-in-out",
            showMenu ? "opacity-100" : "opacity-0"
          )}
        />
        {/* 菜单本体，带滑入滑出动画 */}
        <div
          className={clsx(
            "fixed top-[64px] left-0 z-50 py-5 w-[180px] rounded-none",
            `h-[calc(100vh-${TOP}px)]`,
            "backdrop-blur-md bg-white/80 shadow-xl border-none transition-all duration-300 ease-in-out",
            showMenu ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0"
          )}
          onClick={e => e.stopPropagation()}
          tabIndex={-1}
          aria-label="menu"
          style={{ willChange: "transform, opacity" }}
        >
          {(isLogin ? tabs : tabs.slice(0, 1).concat(tabs.slice(2))).map((tab, index) => (
            <Link
              onClick={() => setShowMenu(false)}
              key={tab.name}
              href={tab.href}
              className={clsx(
                "w-full flex items-center gap-3 hover:text-black hover:font-semibold transition-all duration-300 py-2 px-4",
                "text-gray-600",
                showMenu
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-4"
              )}
              style={{
                transitionDelay: showMenu ? `${index * 50}ms` : "0ms"
              }}
            >
              <span>{tab.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
